import { __awaiter } from '../../../external_node_modules/tslib/tslib.es6.js';
import { getStorefrontByPlatform } from '../../../api/storefront.js';
import { PLATFORMS } from '../../../constants/platforms.js';
import { ProductEntity } from '../../entity/product.entity.js';
import settings from '../../../settings.js';
import { log } from '../../../utils/logger.js';
import { memoizeAsync } from '../../../utils/memoize.js';

function fetchProductsObject(customStorefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        const { products } = yield getStorefrontByPlatform(PLATFORMS.STEAM, customStorefrontName);
        const productsEntities = {};
        for (const productId in products) {
            productsEntities[productId] = new ProductEntity(products[productId], PLATFORMS.STEAM, settings.language, settings.country);
        }
        log('[Steam]', 'Save products to cache', productsEntities);
        return productsEntities;
    });
}
const getProductsObject = memoizeAsync(fetchProductsObject.name, fetchProductsObject);
function getProducts(customStorefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        const products = yield getProductsObject(customStorefrontName);
        return Object.values(products);
    });
}

export { getProducts, getProductsObject };
//# sourceMappingURL=products.js.map
